import * as Joi from 'joi';
import { AuditSettingForm } from '../../../models';

const auditSettingsSchema = Joi.object<AuditSettingForm>({
  firstGeneratedDate: Joi.date().messages({
    'date.base': 'Please select Report Generated Start Date',
  }),
  repeat: Joi.any(),
  reviewDeadline: Joi.number()
    .required()
    .min(1)
    .when('repeat.code', {
      is: 'MONTHLY',
      then: Joi.number().max(30).messages({
        'number.max': 'You can only enter numbers from 1 to 30.',
        'number.min': 'You can only enter numbers from 1 to 30.',
      }),
      otherwise: Joi.number().max(365).messages({
        'number.max': 'You can only enter numbers from 1 to 365.',
        'number.min': 'You can only enter numbers from 1 to 365.',
      }),
    })
    .messages({
      'number.base': 'Review Deadline must be a number',
    }),
  reminderReviewRepeat: Joi.any(),
});

export default auditSettingsSchema;
